import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {fetchUserApplications} from '../redux/actions';
import {
    userSelector,
    applicationSelector,
    authSelector
} from '../redux/selectors'
import { toArray } from '../common/util';
import ApplicationList from "./ApplicationList";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

class Applications extends Component {

    componentDidMount() {
        document.title = "Addiction | Applications";
        this.props.getUserApplications(this.props.auth.currentUser.slug);
    }

    render() {
        return (
            <div>
                <h1>Applications</h1>
                 <ApplicationList applications={
                    toArray(this.props.applications)
                    .filter(application => application.user === this.props.auth.currentUser.id)
                    .sort((a, b) => (new Date(a.lastUpdated).getTime() - new Date(b.lastUpdated).getTime()))
                    }
                    users={this.props.users}
                    location="/applications/"
                />
                <div className="panel-adt clearfix">
                    <Link className="pull-right" to="/apply"><FontAwesomeIcon className="text-primary" icon={faPlus} fixedWidth /> Create New Application</Link>
                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    applications: applicationSelector(state),
    users: userSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getUserApplications: (user) => dispatch(fetchUserApplications(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Applications);


// WEBPACK FOOTER //
// ./src/Applications/Applications.js